import { CommonResponse } from '@gtpl/shared-models/masters';
import { AllReceiveSubplantStockResponseModel } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ReceiveStockDto } from '../dto/receive-stock.dto';
import { SendStockDto } from '../dto/send-stock.dto';
import { UnitRequest } from '../dto/unit.id.request';
import { StockTransferService } from './stock-transfer.service';
@ApiTags('stock-transfer')
@Controller('stock-transfer')
export class StockTransferController {
        constructor(private stockTransferService: StockTransferService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/sendStock')
    async sendStock(@Body() inputReq: SendStockDto): Promise<CommonResponse> {
        try {
            return await this.stockTransferService.sendStock(inputReq.sendStocks);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/receiveStock')
    async receiveStock(@Body() inputReq: ReceiveStockDto): Promise<CommonResponse> {
        try {
            return await this.stockTransferService.receiveStock(inputReq.receivedStocks);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getAllReceiveSubplantStock')
    async getAllReceiveSubplantStock(@Body() plantReq:UnitRequest): Promise<AllReceiveSubplantStockResponseModel> {
        try {
            return await this.stockTransferService.getAllReceiveSubplantStock(plantReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllReceiveSubplantStockResponseModel, error);
        }
    }


}
